import { SortDescriptor } from "@progress/kendo-data-query";
import { orderBy } from "@progress/kendo-react-data-tools";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid"
import { useState } from "react";

const ReportsTable4 = (Props: any) => {

    const initialSort: Array<SortDescriptor> = [
        { field: "company_name", dir: "asc" },
      ];
    
      const [sort, setSort] = useState(initialSort);
    
    return (
        <Grid
            // data={props.state.items && orderBy (props.state.items, sort, 'asc')}
            data={Props.data}
            >
            <Column field="beginningOfTheMonth" title="Total Active contracts at the beginning of the month" />
            <Column field="startingThisMonth" title="Contracts Starting this month" />
            <Column field="endingThisMonth" title="Contracts Ending this month"/>
            <Column field="extendedThisMonth" title="Contracts Extended this month"/>
            <Column field="terminatedThisMonth" title="Contracts Terminated this month"/>
            <Column field="endOfTheMonth" title="Total active contracts end of the month"/>

        </Grid>
    )
}


export default ReportsTable4